import React, { useState, useEffect } from "react";
import api from "../../api/api";
import { useLocation } from "react-router-dom";
import { TimePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import dayjs from "dayjs";
const EditSelected = ({ ismodal, tab,setOpen,setAlertMessage,activeFilter,setSeverity, setismodal,tableData,formData,setFormData, updatemutiple, selectedData ,selectedRows}) => {


  const [jobDescription, setJobDescription] = useState("");
  const [costDescription, setCostDescription] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [costSuggestions, setCostSuggestions] = useState([]);
  const [showCostSuggestions, setShowCostSuggestions] = useState(false);
  const [disableTimeFields, setDisableTimeFields] = useState(false);
  const [jobNotFound, setJobNotFound] = useState(false);
const [costNotFound, setCostNotFound] = useState(false);

  const location =useLocation()
  const queryParams = new URLSearchParams(location.search);
  const companyid = queryParams.get("companyid");
  useEffect(() => {
    if (selectedData) {
      setFormData({
        clock_in: selectedData.clock_in?.slice(11, 16) || "",
        clock_out: selectedData.clock_out?.slice(11, 16) || "",
        job_id: selectedData.job_id || "",
        cost_code_id: selectedData.cost_code_id || "",
        break_time: selectedData.break_time || "",
        perdim: selectedData.perdim || "",
      });
      setJobDescription(selectedData.jobDescription || "");
      setCostDescription(selectedData.costcodeDescription || "");
    }
  }, [selectedData]);
  const toUTC = (time) => {
    if (!time) return time;
  
    const today = dayjs().format("YYYY-MM-DD");
    const fullTime = `${today} ${time}`; // "YYYY-MM-DD HH:mm"
  
    return dayjs.tz(fullTime, "YYYY-MM-DD HH:mm", "America/Chicago") // DST-aware Central
      .utc()
      .format("HH:mm");
  };
  const validateSelectedRows = () => {
  const toMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };

  for (let id of selectedRows) {
    const row = tableData.find((r) => r.id === id);
    if (!row) continue;

    // 🚀 Skip equipment rows completely
    if (row.etype === "EQP") continue;

    const employeeName = row.emp_name || `Row ${id}`;

    const clockIn = formData.clock_in || row.clock_in?.slice(11, 16);
    const clockOut = formData.clock_out || row.clock_out?.slice(11, 16);

    if (!clockIn || !clockOut) continue;

    const clockInMin = toMinutes(clockIn);
    const clockOutMin = toMinutes(clockOut);

    // ❌ Clock order validation
    if (clockOutMin <= clockInMin) {
      setSeverity("error");
      setAlertMessage(
        `Clock Out must be greater than Clock In for ${employeeName}`
      );
      setOpen(true);
      return false;
    }

    const duration = clockOutMin - clockInMin;

    const breakTime =
      formData.break_time !== ""
        ? Number(formData.break_time)
        : Number(row.break_time || 0);

    let splitMinutes = 0;

    tableData.forEach((item) => {
      if (item.emp_id === row.emp_id && item.is_split === "Y") {
        const [h = 0, m = 0] = (item.hours || "00:00").split(":").map(Number);
        splitMinutes += h * 60 + m;
      }
    });

    const requiredMinutes = splitMinutes + breakTime;

    // ❌ Duration validation
    if (duration < requiredMinutes) {
      setSeverity("error");
      setAlertMessage(
        `Invalid duration for ${employeeName}. Clock time must be greater than split hours + break time.`
      );
      setOpen(true);
      return false;
    }
  }

  return true;
};
  useEffect(() => {
    const isAnySplit = selectedRows.some((id) => {
      const matchedRow = tableData.find((row) => row.id === id);
      return matchedRow?.is_split === 'Y';
    });
    setDisableTimeFields(isAnySplit);
  }, [selectedRows, tableData]);
  
  const handleHoursBlur = () => {
  let value = formData.hours?.replace(/\D/g, "") || "";

  if (!value) return;

  if (value.length <= 2) {
    // Treat as hours only → pad with :00
    let h = value.padStart(2, "0");
    value = `${h}:00`;
  } else {
    // Split hours and minutes
    let h = value.slice(0, 2).padStart(2, "0");
    let m = value.slice(2, 4).padEnd(2, "0");
    if (parseInt(m) > 59) m = "59"; // cap minutes
    value = `${h}:${m}`;
  }

  setFormData((prev) => ({
    ...prev,
    hours: value,
  }));
};

const handleChange = (field) => (e) => {
  let value = e.target.value;

  if (field === "hours") {
    // Remove everything except digits
    value = value.replace(/\D/g, "");

    // Auto-insert colon
    if (value.length > 2) {
      value = value.slice(0, 2) + ":" + value.slice(2, 4);
    }
  } else if (["job_id", "cost_code_id", "break_time"].includes(field)) {
    value = value.replace(/\D/g, ""); // digits only
  } else if (field === "perdim") {
    value = value.toString();
  }else if (field === "unit") {
  value = value.toString(); // force string, even though input type="number"
}

  setFormData((prev) => ({
    ...prev,
    [field]: value,
  }));

  if (field === "job_id") {
    fetchJobSuggestions(value);
    setJobDescription("");
  } else if (field === "cost_code_id") {
    fetchCostSuggestions(value);
    setCostDescription("");
  }
};

 const fetchJobSuggestions = async (query) => {
  if (!query) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  try {
    const res = await api.get(`/v1/timesheets/get-jobs`, {
      params: {
        company_id: companyid,
        job_num: query,
      },
    });

    let results = [];
    if (res.status === 200 && Array.isArray(res.data)) {
      results = res.data;
    }

    // Add custom "Overhead" entry for 0000
    if (/^0{1,4}$/.test(query)) {
      results = [
        ...results,
        { job_num: "0000", job_name: "Overhead" }
      ];
    }

    if (results.length) {
      setJobNotFound(false)
      setSuggestions(results);
      setShowSuggestions(true);
    } else {
      setJobNotFound(true)
      
      setSuggestions([]);
      setShowSuggestions(false);
      //  setFormData((prev) => ({ ...prev, job_id: "" }))
    }
  } catch (err) {
    console.error("Job fetch error", err);
      setJobNotFound(true)
    //  setFormData((prev) => ({ ...prev, job_id: "" }));
  }
};


  const fetchCostSuggestions = async (query) => {
    if (!query) {
      setCostSuggestions([]);
      setShowCostSuggestions(false);
      return;
    }
    try {
if (/^0{1,4}$/.test(query)) {
  setCostSuggestions([{ cost_code: '0000', costcode_name: 'Overhead' }]);
  setShowCostSuggestions(true);
      setCostNotFound(false)

} else {
  const res = await api.get(`/v1/timesheets/get-costcodes`, {
    params: {
      company_id: companyid,
      cost_code: query,
    },
  });

  if (res.status === 200 && res.data.length) {
    setCostNotFound(false)
    setCostSuggestions(res.data);
    setShowCostSuggestions(true);
  } else {
   setCostNotFound(true)
    setCostSuggestions([]);
    setShowCostSuggestions(false);

    // setFormData((prev) => ({ ...prev, cost_code_id: "" }));
  }
}

    } catch (err) {
      console.error("Cost fetch error", err);
    setCostNotFound(true)
        // setFormData((prev) => ({ ...prev, cost_code_id: "" }));
    }
  };

 const handleSelect = (field, value, description) => {
  const parsedValue =
    (field === "job_id" || field === "cost_code_id") && value === "0000"
      ? "0000"
      : parseInt(value);

  setFormData((prev) => ({ ...prev, [field]: parsedValue }));

  if (field === "job_id") {
    setJobDescription(description);
    setShowSuggestions(false);
  } else {
    setCostDescription(description);
    setShowCostSuggestions(false);
  }
};


  const handleSave = () => {
    const { clock_in, clock_out, job_id, cost_code_id, break_time, perdim } = formData;
  if(costNotFound){
     setSeverity("error")
      setAlertMessage('Cost Code Not Found')
      setOpen(true)
      return
  }
   if(jobNotFound){
     setSeverity("error")
      setAlertMessage('Job Code Not Found')
      setOpen(true)
      return
  }
    const payload = {
      // break_time: Number(break_time), // Always send this
    };
    if (tab === "eqp") {
        if (job_id) payload.job_id = Number(job_id);
    // if (cost_code_id) payload.cost_code_id = Number(cost_code_id);
    if (formData?.hours) payload.hours = formData?.hours;

      if (formData?.quantity) payload.quantity = Number(formData?.quantity);
      if (formData?.unit) payload.unit = formData?.unit.toString();
  } else {
    payload.break_time = Number(break_time) || 0;
    if (job_id) payload.job_id = Number(job_id);
    if (cost_code_id) payload.cost_code_id = Number(cost_code_id);
    if (perdim) payload.perdim = perdim.toString();

    if (!disableTimeFields) {
      if (clock_in) payload.clock_in =toUTC(clock_in);
      if (clock_out) payload.clock_out = toUTC(clock_out);
    }

     if (costDescription) payload.costcodeDescription = costDescription;
  }
  
   
    if (jobDescription) payload.jobDescription = jobDescription;
  
    console.log("Form Submitted:", payload);
    if (tab !== "eqp" && !disableTimeFields) {
  const isValid = validateSelectedRows();
  if (!isValid) return;
}
    updatemutiple(payload);
  
  };
  
  

  const handleClose = () => {
    setFormData({
      clock_in: "",
      clock_out: "",
      job_id: "",
      cost_code_id: "",
      break_time: "",
      perdim: "",
    });
    setSuggestions([]);
    setCostSuggestions([]);
    setJobDescription("");
    setCostDescription("");
    setShowSuggestions(false);
    setShowCostSuggestions(false);
    setismodal(false);
  };
const handlejobKeyDown = (e) => {
  if (e.key === "Tab" && showSuggestions && suggestions.length > 0) {
    e.preventDefault(); // prevent focus change
    const firstSuggestion = suggestions[0];
    handleSelect("job_id", firstSuggestion?.job_num, firstSuggestion?.job_name);
  }
};
const handleCostKeyDown = (e) => {
  if (e.key === "Tab" && showCostSuggestions && costSuggestions.length > 0) {
    e.preventDefault(); // Stop normal tabbing
    const firstSuggestion = costSuggestions[0];
    handleSelect("cost_code_id", firstSuggestion?.cost_code, firstSuggestion?.costcode_name);
  }
};


  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg relative">
        <button
          className="absolute top-3 right-4 text-gray-500 hover:text-gray-800 text-lg"
          onClick={handleClose}
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-6 text-center">Edit Selected</h2>

        <div className="flex flex-col gap-4">


          {/* Job Number */}
          <div className="flex flex-col text-start relative">
            <label className="text-sm font-medium mb-1">Job Number</label>
            <input
              type="number"
              value={formData.job_id}
              onChange={handleChange("job_id")}
                onKeyDown={handlejobKeyDown}
              className="p-2 w-full text-sm border border-gray-300 rounded focus:outline-none"
              placeholder="Job Number"
            />
            {showSuggestions && (
              <ul className="absolute bg-white border top-[90%] border-gray-200 w-full mt-1 max-h-40 overflow-y-auto rounded shadow z-10">
                {suggestions.map((item, idx) => (
                  <li
                    key={idx}
                    onClick={() => handleSelect("job_id", item?.job_num, item?.job_name)}
                    className="px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                  >
                   {item?.job_num} - {item?.job_name}
                  </li>
                ))}
              </ul>
            )}
            {jobDescription && <p className="text-xs text-gray-600 mt-1">{jobDescription}</p>}
            {jobNotFound&&<p className="text-xs text-red-500 mt-1">No Job code found</p>}
          </div>

         {tab=='eqp' ?<>
         <>
    

    {/* Quantity */}
    <InputField
      label="Quantity"
      type="number"
      value={formData.quantity || ""}
      onChange={handleChange("quantity")}
      placeholder="Enter quantity"
    />

    {/* Unit (number input but saved as string) */}
    <InputField
      label="Unit"
      type="number"
      value={formData.unit || ""}
      onChange={handleChange("unit")}
      placeholder="Enter unit"
    />
  </>
         </>
:          <div className="flex flex-col text-start relative">
            <label className="text-sm font-medium mb-1">Cost Code</label>
            <input
              type="number"
              value={formData.cost_code_id}
              onChange={handleChange("cost_code_id")}
                onKeyDown={handleCostKeyDown}
              className="p-2 w-full text-sm border border-gray-300 rounded focus:outline-none"
              placeholder="Cost Code"
            />
            {showCostSuggestions && (
              <ul className="absolute top-[90%] bg-white border border-gray-200 w-full mt-1 max-h-40 overflow-y-auto rounded shadow z-10">
                {costSuggestions.map((item, idx) => (
                  <li
                    key={idx}
                    onClick={() => handleSelect("cost_code_id", item?.cost_code, item?.costcode_name)}
                    className="px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                  >
                   {item?.cost_code} -  {item?.costcode_name}
                  </li>
                ))}
              </ul>
            )}
            {costDescription && <p className="text-xs text-gray-600 mt-1">{costDescription}</p>}
             {costNotFound&&<p className="text-xs text-red-500 mt-1">No Cost code found</p>}
          </div>
}
        

        </div>
        {/* Conditionally render based on activeFilter.label */}
{tab=='eqp' ? (
  <div className="mt-3">
  <InputField
    label="Hours"
    type="text"
    inputMode="numeric"
    placeholder="HH:MM"
    value={formData.hours || ""}
     onBlur={handleHoursBlur}  
    onChange={handleChange("hours")}
  />


  </div>

) : (
  <>
    {/* Clock In */}
    <div className="flex flex-col">
      <label className="text-sm font-medium mb-1 text-start">Clock In</label>
      <TimePicker
        format="hh:mm aa"
        showMeridiem
        disabled={disableTimeFields}
        value={
          formData.clock_in
            ? new Date(`1970-01-01T${formData.clock_in}`)
            : null
        }
        onChange={(value) =>
          setFormData((prev) => ({
            ...prev,
            clock_in: value ? value.toTimeString().slice(0, 5) : "",
          }))
        }
        className="w-full text-sm border border-gray-300 rounded mb-4"
      />
    </div>

    {/* Clock Out */}
    <div className="flex flex-col">
      <label className="text-sm font-medium mb-1 text-start">Clock Out</label>
      <TimePicker
        format="hh:mm aa"
        showMeridiem
        disabled={disableTimeFields}
        value={
          formData.clock_out
            ? new Date(`1970-01-01T${formData.clock_out}`)
            : null
        }
        onChange={(value) =>
          setFormData((prev) => ({
            ...prev,
            clock_out: value ? value.toTimeString().slice(0, 5) : "",
          }))
        }
        className="w-full text-sm border border-gray-300 rounded"
      />
    </div>

    <InputField
      label="Break Time"
      type="number"
      disabled={disableTimeFields}
      value={formData.break_time}
      onChange={handleChange("break_time")}
      placeholder="Break Time"
    />

    <InputField
      label="Per Diem"
      type="text"
      value={formData.perdim}
      onChange={handleChange("perdim")}
      placeholder="Per Diem"
    />
  </>
)}


        <div className="mt-6 flex">
          <button
            className="px-4 w-full py-2 text-sm rounded border border-[#900] text-white bg-[#900] hover:bg-red-800"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

const InputField = ({ label, ...rest }) => (
  <div className="flex flex-col text-start">
    <label className="text-sm font-medium mb-1">{label}</label>
    <input
      {...rest}
      className="p-2 w-full text-sm border border-gray-300 rounded focus:outline-none"
    />
  </div>
);

export default EditSelected;
